"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.giveRandomNumber = exports.generateBgSecondaryOffer = exports.addQuery = void 0;

const giveRandomNumber = (min, max) => Math.floor(Math.random() * max) + min;

exports.giveRandomNumber = giveRandomNumber;

const addQuery = (selector, styleStr) => {
  let css = '';
  css += `${selector} {${styleStr}}`;
  const head = document.head || document.getElementsByTagName('head')[0];
  const style = document.createElement('style');
  style.type = 'text/css';

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }

  head.appendChild(style);
};

exports.addQuery = addQuery;

const generateBgSecondaryOffer = (idSecondaryOffer, bgImage) => {
  if (idSecondaryOffer && bgImage) {
    const bgImageUrl = `url(${bgImage})`;
    addQuery(`#${idSecondaryOffer}`, `background-image: ${bgImageUrl};,
        background-size: cover;`);
  }
};

exports.generateBgSecondaryOffer = generateBgSecondaryOffer;

//# sourceMappingURL=secondaryOfferUtils.js.map